import { Page } from "../Page/Page.tsx";
import { FailureView } from "./FailureView.tsx";

export function NotFoundPage() {
  return (
    <Page backHref="~/" title="" centerChildren>
      <FailureView failure={{ type: "UNKNOWN_PATH" }} />
    </Page>
  );
}
